import { Injectable } from '@angular/core';
import { WsClient } from '@shared/index';
import { waitSeconds } from '@reflact/tsutil';
import { UsertokenService } from '@shared-angular/services/usertoken.service';

@Injectable({
    providedIn: 'root'
})
export class DebugSocketService {
    private debugSocket?: WsClient;
    private currentBotId?: string;

    constructor(private usertokenService: UsertokenService) { }

    public connectToDebug(botid: string) {
        // Recreate socket when botId changes — the server context (room) is
        // fixed to the connection-time botId and cannot be switched mid-session.
        if (this.debugSocket != null && this.currentBotId === botid) {
            return;
        }
        if (this.debugSocket != null) {
            this.debugSocket.disconnect();
            this.debugSocket = undefined;
        }
        this.currentBotId = botid;
        this.debugSocket = new WsClient({
            autoConnect: true,
            path: '/api/ws-debug',
            extraHeaders: {
                Ut: "" + this.usertokenService.getUserToken(),
                botid
            },
            // Re-read the token on every reconnect (timer-, visibility- or
            // online-triggered) instead of reusing the snapshot taken above —
            // without this, a socket that outlives the token's lifetime (1 day)
            // reconnects forever with an already-expired token.
            refreshAuthParams: () => ({ Ut: "" + this.usertokenService.getUserToken(), botid })
        });
    }

    public async getDebugIo(): Promise<WsClient> {
        if (this.debugSocket) {
            return this.debugSocket;
        }
        await waitSeconds(1);
        return this.getDebugIo();
    }
}
